var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaringRedRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 6.5293C13.25 9.98109 10.4518 12.7793 7 12.7793C3.54822 12.7793 0.75 9.98109 0.75 6.5293C0.75 3.07752 3.54822 0.279297 7 0.279297C10.4518 0.279297 13.25 3.07752 13.25 6.5293ZM7.78125 9.6543C7.78125 10.0858 7.43148 10.4355 7 10.4355C6.56853 10.4355 6.21875 10.0858 6.21875 9.6543C6.21875 9.22281 6.56853 8.87305 7 8.87305C7.43148 8.87305 7.78125 9.22281 7.78125 9.6543ZM7 2.62305C6.56853 2.62305 6.21875 2.97283 6.21875 3.4043V6.5293C6.21875 6.96078 6.56853 7.31055 7 7.31055C7.43148 7.31055 7.78125 6.96078 7.78125 6.5293V3.4043C7.78125 2.97283 7.43148 2.62305 7 2.62305Z",
    fill: "#A81F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaringRedRound);
export default __webpack_public_path__ + "static/media/WaringRedRound.1df59043911c105c4ae3925dceb3a3fe.svg";
export { ForwardRef as ReactComponent };